import { useQuery } from '@tanstack/vue-query';

import { useTeamCookie } from '@/shared/hooks/use-team-cookie';

import { limitsQueryOptions } from '../queries';

export function useLimits() {
  const { currentTeamUuid } = useTeamCookie();
  return useQuery(limitsQueryOptions(currentTeamUuid));
}
